export const steps = {
  "sole-proprietor": ["personal", "business", "kyc"],
  "private-limited-liability-company": [
    "personal",
    "business",
    "shareholders",
    "directors",
    "kyc",
  ],
  "public-limited-liability-company": [
    "personal",
    "business",
    "directors",
    "shareholders",
    "kyc",
  ],
  "non-government-organization": [
    "personal",
    "business",
    "trustees",
    "authorizers",
    "kyc",
  ],
  "government-body": ["personal", "business", "kyc"],
  "professional-body": [
    "personal",
    "business",
    "trustees",
    "authorizers",
    "kyc",
  ],
};

export const individualSteps = ["personal", "kyc"];

export const accountTypes = [
  { label: "Individual", key: "individual-account" },
  { label: "Business", key: "business-account" },
];

export const businessCategories = [
  { label: "Sole Proprietor", key: "sole-proprietor", disabled: false },
  {
    label: "Private Limited Liability Company",
    key: "private-limited-liability-company",
    disabled: false,
  },
  // {
  // 	label: "Public Limited Liability Company",
  // 	key: "public-limited-liability-company",
  // 	disabled: true,
  // },
  // {
  // 	label: "Non Governmental Organization",
  // 	key: "non-government-organization",
  // 	disabled: true,
  // },
  // { label: "Government Body", key: "government-body", disabled: true },
  // { label: "Professional Body", key: "professional-body", disabled: true },
];

export const sections = [
  { label: "Personal Information", key: "personal" },
  { label: "Business Information", key: "business" },
  { label: "Director's Information", key: "directors" },
  { label: "Shareholder's Information", key: "shareholders" },
  { label: "Trustee's Information", key: "trustees" },
  { label: "Authorizer's Information", key: "authorizers" },
  { label: "KYC Documents", key: "kyc" },
];

export const personalInformation = [
  { label: "First Name", key: "firstName", value: "" },
  { label: "Middle Name", key: "middleName", value: "" },
  { label: "Last Name", key: "lastName", value: "" },
  { label: "Phone Number", key: "phoneNumber", value: "" },
  { label: "Email Address", key: "email", value: "" },
  { label: "Gender", key: "gender", value: "", type: "select" },
  { label: "Nationality", key: "nationality", value: "" },
  { label: "National Identification Number (NIN)", key: "nin", value: "" },
  { label: "State of Origin", key: "stateOfOrigin", value: "", type: "select" },
  { label: "L.G.A of Origin", key: "lgaOfOrigin", value: "", type: "select" },
  {
    label: "State of Residence",
    key: "stateOfResidence",
    value: "",
    type: "select",
  },

  {
    label: "L.G.A of Residence",
    key: "lgaOfResidence",
    value: "",
    type: "select",
  },
  { label: "Residential Address", key: "residentialAddress", value: "" },
  { label: "Landmark", key: "landmark", value: "", optional: true },
  {
    label: "Social Media Platform",
    key: "socialMediaPlatform",
    value: "",
    type: "select",
    optional: true,
  },
  {
    label: "Social Media Handle",
    key: "socialMediaHandle",
    value: "",
    optional: true,
  },
  { label: "Agent Category", key: "merchantId", value: "", type: "select" },
  {
    label: "Password",
    key: "password",
    value: "",
    type: "password",
    showPassword: false,
  },
  {
    label: "Password Confirmation",
    key: "confirmation",
    value: "",
    type: "password",
    showPassword: false,
  },
];

export const sourceOfIncome = [
  { label: "Occupation", key: "occupation", value: "", type: "select" },
  {
    label: "What is your annual income?",
    key: "annualIncome",
    value: "",
    type: "select",
  },
  {
    label: "Other sources of income?",
    key: "others",
    value: "",
    type: "select",
  },
  {
    label: "Other Occupation",
    key: "otherOccupation",
    value: "",
    type: "select",
    show: false,
  },
  {
    label: "What is your annual income (other source)?",
    key: "otherAnnualIncome",
    value: "",
    type: "select",
    show: false,
  },
];

export const businessIncome = [
  {
    label: "What is your business annual income?",
    key: "annualIncome",
    value: "",
    type: "select",
    dynamic: false,
  },
  {
    label: "Other sources of business income",
    key: "others",
    value: "",
    type: "select",
  },
  {
    label: "Industry",
    key: "otherIndustry",
    value: "",
    type: "select",
    show: false,
    dynamic: false,
  },
  {
    label: "What is your annual income (other source)",
    key: "otherAnnualIncome",
    value: "",
    type: "select",
    show: false,
    dynamic: false,
  },
];

export const annualIncome = [
  { label: "Less than ₦50,000", key: "Less than ₦50,000", value: "" },
  { label: "₦51,000 - ₦250,000", key: "₦51,000 - ₦250,000", value: "" },
  { label: "₦251,000 - ₦500,000", key: "₦251,000 - ₦500,000", value: "" },
  {
    label: "₦501,000 - Less than ₦1 Million",
    key: "₦501,000 - Less than ₦1 million",
    value: "",
  },
  {
    label: "₦1 Million - Less than ₦5 Million",
    key: "₦1 million - Less than ₦5 million",
    value: "",
  },
  {
    label: "₦5 Million - Less than ₦10 Million",
    key: "₦5 million - Less than ₦10 million",
    value: "",
  },
  {
    label: "₦10 Million - Less than ₦20 Million",
    key: "₦10 million - Less than ₦20 million",
    value: "",
  },
  {
    label: "₦20 Million - Less than ₦100 Million",
    key: "₦20 million - Less than ₦100 million",
    value: "",
  },
  { label: "Above ₦100 Million", key: "Above ₦100 million", value: "" },
];

export const otherOccupation = [
  { label: "Yes", key: "yes", value: "" },
  { label: "No", key: "no", value: "" },
];

export const businessInformation = [
  { label: "Business Name", key: "businessName", value: "" },
  { label: "Email Address", key: "businessEmail", value: "" },
  { label: "Phone Number", key: "businessPhoneNumber", value: "" },
  { label: "RC Number", key: "rcNumber", value: "" },
  {
    label: "Date of Incorporation",
    key: "registrationDate",
    type: "date",
    value: "",
  },
  { label: "Business Address", key: "businessAddress", value: "" },
  { label: "State", key: "businessState", type: "select", value: "" },
  { label: "LGA", key: "businessLGA", type: "select", value: "" },
];

export const agentInformation = [
  { label: "First Name", key: "firstName", type: "text", value: "" },
  { label: "Middle Name", key: "middleName", type: "text", value: "" },
  { label: "Last Name", key: "lastName", type: "text", value: "" },
  { label: "Gender", key: "gender", type: "select", value: "" },
  { label: "State of Origin", key: "state", type: "select", value: "" },
  { label: "L.G.A", key: "lga", type: "select", value: "" },
  {
    label: "Residential Address",
    key: "address",
    type: "text",
    value: "",
  },
  {
    label: "National Identification Number (NIN)",
    key: "nin",
    type: "text",
    value: "",
  },
];

export const businessIndustries = [
  { label: "Accounting Services", key: "Accounting Services", value: "" },
  { label: "Audit Services", key: "Audit Services", value: "" },
  { label: "Automobile Dealership", key: "Automobile Dealership", value: "" },
  { label: "Aviation", key: "Aviation", value: "" },
  { label: "Alternative Medicine", key: "Alternative Medicine", value: "" },
  { label: "Apparel and Fashion", key: "Apparel and Fashion", value: "" },
  { label: "Architecture/Planning", key: "Architecture/Planning", value: "" },
  { label: "Arts and Crafts", key: "Arts and Crafts", value: "" },
  { label: "Broadcast Media", key: "Broadcast Media", value: "" },
  {
    label: "Charity/Humanitarian Organization",
    key: "Charity/Humanitarian Organization",
    value: "",
  },
  {
    label: "Clearing and Forwarding Services",
    key: "Clearing and Forwarding Services",
    value: "",
  },
  { label: "Club/Association", key: "Club/Association", value: "" },
  { label: "Construction Services", key: "Construction Services", value: "" },
  { label: "Consulting Services", key: "Consulting Services", value: "" },
  { label: "Cooperative Society", key: "Cooperative Society", value: "" },
  { label: "Consumer Electronics", key: "Consumer Electronics", value: "" },
  { label: "Consumer Goods", key: "Consumer Goods", value: "" },
  { label: "E-commerce", key: "E-commerce", value: "" },
  { label: "Education", key: "Education", value: "" },
  { label: "Environmental Services", key: "Environmental Services", value: "" },
  {
    label: "Estate Surveyor and Valuer Services",
    key: "Estate Surveyor and Valuer Services",
    value: "",
  },
  { label: "Events Services", key: "Events Services", value: "" },
  { label: "Facilities Services", key: "Facilities Services", value: "" },
  {
    label: "Farming (Non Mechanized)",
    key: "Farming (Non Mechanized)",
    value: "",
  },
  { label: "Food Services", key: "Food Services", value: "" },
  {
    label: "Financial Services (Bureau De Change)",
    key: "Financial Services (Bureau De Change)",
    value: "",
  },
  {
    label: "Financial Services (International Money Transfer Operator)",
    key: "Financial Services (International Money Transfer Operator)",
    value: "",
  },
  {
    label: "Financial Services (Mobile Money Operator)",
    key: "Financial Services (Mobile Money Operator)",
    value: "",
  },
  {
    label: "Financial Services (Payment Solution Service Provider)",
    key: "Financial Services (Payment Solution Service Provider)",
    value: "",
  },
  {
    label: "Financial Services (POS Operator)",
    key: "Financial Services (POS Operator)",
    value: "",
  },
  {
    label: "Gambling and Lottery Services",
    key: "Gambling and Lottery Services",
    value: "",
  },
  { label: "Health Care", key: "Health Care", value: "" },
  { label: "Health and Fitness", key: "Health and Fitness", value: "" },
  { label: "Hospitality Services", key: "Hospitality Services", value: "" },
  {
    label: "Import and Export Services",
    key: "Import and Export Services",
    value: "",
  },
  { label: "Information Technology", key: "Information Technology", value: "" },
  {
    label: "Jewelry and Luxury Goods",
    key: "Jewelry and Luxury Goods",
    value: "",
  },
  { label: "Legal Services", key: "Legal Services", value: "" },
  { label: "Library Services", key: "Library Services", value: "" },
  {
    label: "Marketing and Advertising",
    key: "Marketing and Advertising",
    value: "",
  },
  {
    label: "Mechanized Farming and Equipment Services",
    key: "Mechanized Farming and Equipment Services",
    value: "",
  },
  {
    label: "Mortgage Broker Services",
    key: "Mortgage Broker Services",
    value: "",
  },
  { label: "Music", key: "Music", value: "" },
  {
    label: "Outsourcing and Offshoring",
    key: "Outsourcing and Offshoring",
    value: "",
  },
  { label: "Photography", key: "Photography", value: "" },
  { label: "Printing", key: "Printing", value: "" },
  {
    label: "Precious Stones and Metals",
    key: "Precious Stones and Metals",
    value: "",
  },
  { label: "Professional Training", key: "Professional Training", value: "" },
  {
    label: "Real Estate Agency and Developers Services",
    key: "Real Estate Agency and Developers Services",
    value: "",
  },
  { label: "Recreational Services", key: "Recreational Services", value: "" },
  {
    label: "Religious/Faith based Organization",
    key: "Religious/Faith based Organization",
    value: "",
  },
  { label: "Research Services", key: "Research Services", value: "" },
  { label: "Retail (Petty Trading)", key: "Retail (Petty Trading)", value: "" },
  { label: "Retail (Supermarkets)", key: "Retail (Supermarkets)", value: "" },
  {
    label: "Staffing and Recruiting",
    key: "Staffing and Recruiting",
    value: "",
  },
  {
    label: "Tax Consultancy Services",
    key: "Tax Consultancy Services",
    value: "",
  },
  { label: "Travel", key: "Travel", value: "" },
  {
    label: "Trust and Company Services",
    key: "Trust and Company Services",
    value: "",
  },
  { label: "Telecommunications", key: "Telecommunications", value: "" },
  { label: "Textiles", key: "Textiles", value: "" },
  { label: "Transportation", key: "Transportation", value: "" },
  { label: "Warehousing", key: "Warehousing", value: "" },
  { label: "Other", key: "Other", value: "" },
];

export const companyTypes = [
  {
    label: "Business Name (BN)",
    key: "Business Name (BN)",
    value: "",
  },
  {
    label: "Registered Company (RC)",
    key: "Registered Company (RC)",
    value: "",
  },
];

export const partnershipBusiness = [
  { label: "Yes", key: true, value: true },
  { label: "No", key: false, value: false },
];

export const socialMedia = [
  { label: "Facebook", key: "Facebook", value: "" },
  { label: "Instagram", key: "Instagram", value: "" },
  { label: "Twitter(X)", key: "Twitter(X)", value: "" },
  { label: "LinkedIn", key: "Linkedin", value: "" },
  { label: "TikTok", key: "Tiktok", value: "" },
  { label: "Snapchat", key: "Snapchat", value: "" },
];

export const gender = [
  { label: "Male", key: "male" },
  { label: "Female", key: "female" },
];

export const occupation = [
  { label: "Accountant", key: "Accountant", value: "" },
  { label: "Account Officer", key: "Account Officer", value: "" },
  {
    label: "Administrative Assistant",
    key: "Administrative Assistant",
    value: "",
  },
  { label: "Advertising Executive", key: "Advertising Executive", value: "" },
  {
    label: "Airline Flight Attendant",
    key: "Airline Flight Attendant",
    value: "",
  },
  {
    label: "Airline Flight Operations Administrator",
    key: "Airline Flight Operations Administrator",
    value: "",
  },
  { label: "Airport Administrator", key: "Airport Administrator", value: "" },
  { label: "Animal Breeder", key: "Animal Breeder", value: "" },
  { label: "Animal Trainer", key: "Animal Trainer", value: "" },
  { label: "Architect", key: "Architect", value: "" },
  { label: "Art Director", key: "Art Director", value: "" },
  { label: "Baker", key: "Baker", value: "" },
  { label: "Banker", key: "Banker", value: "" },
  { label: "Bank Manager", key: "Bank Manager", value: "" },
  { label: "Bank Teller", key: "Bank Teller", value: "" },
  { label: "Building Inspector", key: "Building Inspector", value: "" },
  { label: "Carpenter", key: "Carpenter", value: "" },
  { label: "Cashier", key: "Cashier", value: "" },
  { label: "Caterer", key: "Caterer", value: "" },
  { label: "Civil Servant", key: "Civil Servant", value: "" },
  { label: "Compliance Officer", key: "Compliance Officer", value: "" },
  { label: "Construction Worker", key: "Construction Worker", value: "" },
  { label: "Construction Manager", key: "Construction Manager", value: "" },
  { label: "Cook (Cafeteria)", key: "Cook (Cafeteria)", value: "" },
  {
    label: "Cook (Private Household)",
    key: "Cook (Private Household)",
    value: "",
  },
  { label: "Cook (Restaurant)", key: "Cook (Restaurant)", value: "" },
  { label: "Consultant", key: "Consultant", value: "" },
  { label: "Copywriter", key: "Copywriter", value: "" },
  { label: "Counsellor", key: "Counsellor", value: "" },
  { label: "Courier and Messenger", key: "Courier and Messenger", value: "" },
  { label: "Crane Operator", key: "Crane Operator", value: "" },
  { label: "Credit Analyst", key: "Credit Analyst", value: "" },
  {
    label: "Customer Service Representative",
    key: "Customer Service Representative",
    value: "",
  },
  {
    label: "Customer Service Supervisor",
    key: "Customer Service Supervisor",
    value: "",
  },
  { label: "Customs Officer", key: "Customs Officer", value: "" },
  { label: "Database Administrator", key: "Database Administrator", value: "" },
  {
    label: "Dietitian and Nutritionist",
    key: "Dietitian and Nutritionist",
    value: "",
  },
  { label: "Driver (Ambulance)", key: "Driver (Ambulance)", value: "" },
  { label: "Driver (Company)", key: "Driver (Company)", value: "" },
  {
    label: "Driver (Ride-Hailing Service)",
    key: "Driver (Ride-Hailing Service)",
    value: "",
  },
  { label: "Driver (Truck)", key: "Driver (Truck)", value: "" },
  { label: "Engineer", key: "Engineer ", value: "" },
  { label: "Entrepreneur", key: "Entrepreneur", value: "" },
  { label: "Entertainer", key: "Entertainer", value: "" },
  { label: "Executive Secretary", key: "Executive Secretary", value: "" },
  { label: "Event Planner", key: "Event Planner", value: "" },
  { label: "Farmer", key: "Farmer", value: "" },
  { label: "Fashion Designer", key: "Fashion Designer", value: "" },
  { label: "Fashion Model", key: "Fashion Model", value: "" },
  { label: "Finance Manager", key: "Finance Manager", value: "" },
  { label: "Financial Analyst", key: "Financial Analyst", value: "" },
  { label: "Financial Planner", key: "Financial Planner", value: "" },
  { label: "Fitness Trainer", key: "Fitness Trainer", value: "" },
  {
    label: "Forklift and Industrial Truck Operator",
    key: "Forklift and Industrial Truck Operator",
    value: "",
  },
  { label: "Fraud Investigator", key: "Fraud Investigator", value: "" },
  { label: "Graphics Designer ", key: "Graphics Designer", value: "" },
  {
    label: "Home Appliance Installer",
    key: "Home Appliance Installer",
    value: "",
  },
  {
    label: "Home Appliance Repairer",
    key: "Home Appliance Repairer",
    value: "",
  },
  { label: "Hospitality Worker", key: "Hospitality Worker", value: "" },
  { label: "Hotel Manager", key: "Hotel Manager", value: "" },
  { label: "Housekeeper", key: "Housekeeper", value: "" },
  {
    label: "Housekeeping Supervisor",
    key: "Housekeeping Supervisor",
    value: "",
  },
  {
    label: "Human Resources Manager",
    key: "Human Resources Manager",
    value: "",
  },
  { label: "Insurance Agent", key: "Insurance Agent", value: "" },
  { label: "Insurance Lawyer", key: "Insurance Lawyer", value: "" },
  { label: "Interior Designer", key: "Interior Designer", value: "" },
  {
    label: "IT Administrator (Information Technology)",
    key: "IT Administrator (Information Technology)",
    value: "",
  },
  { label: "Journalist", key: "Journalist", value: "" },
  { label: "Land Surveyor", key: "Land Surveyor", value: "" },
  { label: "Lawyer", key: "Lawyer", value: "" },
  { label: "Legal Assistant", key: "Legal Assistant", value: "" },
  { label: "Legal Secretary", key: "Legal Secretary", value: "" },
  { label: "Library Assistant", key: "Library Assistant", value: "" },
  { label: "Loan Officer", key: "Loan Officer", value: "" },
  { label: "Loan Collector", key: "Loan Collector", value: "" },
  {
    label: "Maintenance Supervisor",
    key: "Maintenance Supervisor",
    value: "",
  },
  { label: "Makeup Artist", key: "Makeup Artist", value: "" },
  {
    label: "Manicurist and Pedicurist",
    key: "Manicurist and Pedicurist",
    value: "",
  },
  { label: "Marketing Manager", key: "Marketing Manager", value: "" },
  { label: "Massage Therapist", key: "Massage Therapist", value: "" },
  { label: "Medical Assistant", key: "Medical Assistant", value: "" },
  {
    label: "Medical Laboratory Technician",
    key: "Medical Laboratory Technician",
    value: "",
  },
  { label: "Medical Practitioner", key: "Medical Practitioner", value: "" },
  {
    label: "Medical Records Administrator",
    key: "Medical Records Administrator",
    value: "",
  },
  { label: "Medical Secretary", key: "Medical Secretary", value: "" },
  { label: "Medical Technologist", key: "Medical Technologist", value: "" },
  { label: "Military Officer", key: "Military Officer", value: "" },
  { label: "Music Director", key: "Music Director", value: "" },
  { label: "Office Clerk", key: "Office Clerk", value: "" },
  { label: "Office Supervisor", key: "Office Supervisor", value: "" },
  { label: "On Air Personality", key: "On Air Personality", value: "" },
  { label: "Painter", key: "Painter", value: "" },
  { label: "Petty Trader", key: "Petty Trader", value: "" },
  { label: "Plumber", key: "Plumber", value: "" },
  { label: "Police Officer", key: "Police Officer", value: "" },
  { label: "Procurement Officer", key: "Procurement Officer", value: "" },
  { label: "Product Manager", key: "Product Manager", value: "" },
  { label: "Project Manager", key: "Project Manager", value: "" },
  { label: "Professor", key: "Professor ", value: "" },
  { label: "Property Manager", key: "Property Manager", value: "" },
  {
    label: "Public Health Service Officer",
    key: "Public Health Service Officer",
    value: "",
  },
  {
    label: "Public Relations Manager",
    key: "Public Relations Manager",
    value: "",
  },
  {
    label: "Quality Control Officer",
    key: "Quality Control Officer",
    value: "",
  },
  { label: "Real Estate Agent", key: "Real Estate Agent", value: "" },
  { label: "Receptionist", key: "Receptionist", value: "" },
  { label: "Retail Store Manager", key: "Retail Store Manager", value: "" },
  { label: "Sales Manager", key: "Sales Manager", value: "" },
  {
    label: "Sales Representative (Agricultural Products)",
    key: "Sales Representative (Agricultural Products)",
    value: "",
  },
  {
    label: "Sales Representative (Automobiles)",
    key: "Sales Representative (Automobiles)",
    value: "",
  },
  {
    label: "Sales Representative (Chemicals & Drugs)",
    key: "Sales Representative (Chemicals & Drugs)",
    value: "",
  },
  {
    label: "Sales Representative (Computers)",
    key: "Sales Representative (Computers)",
    value: "",
  },
  {
    label: "Sales Representative (Financial Services)",
    key: "Sales Representative (Financial Services)",
    value: "",
  },
  {
    label: "Sales Representative (Medical Equipment)",
    key: "Sales Representative (Medical Equipment)",
    value: "",
  },
  {
    label: "Sales Representative (Retail)",
    key: "Sales Representative (Retail)",
    value: "",
  },
  {
    label: "Sales Representative (Telecommunications)",
    key: "Sales Representative (Telecommunications)",
    value: "",
  },
  {
    label: "Sales Representative (Education Programs)",
    key: "Sales Representative (Education Programs)",
    value: "",
  },
  {
    label: "Sales Representative (Mechanical Equipment)",
    key: "Sales Representative (Mechanical Equipment)",
    value: "",
  },
  {
    label: "Sales Representative (Other)",
    key: "Sales Representative (Other)",
    value: "",
  },
  { label: "Security Officer", key: "Security Officer", value: "" },
  { label: "Secretary", key: "Secretary", value: "" },
  {
    label: "Social and Human Service Assistant",
    key: "Social and Human Service Assistant",
    value: "",
  },
  {
    label: "Social Service Volunteer",
    key: "Social Service Volunteer",
    value: "",
  },
  {
    label: " Social Welfare Administrator",
    key: " Social Welfare Administrator",
    value: "",
  },
  { label: "Social Worker", key: "Social Worker", value: "" },
  { label: "Software Engineer", key: "Software Engineer", value: "" },
  { label: "Speech Writer", key: "Speech Writer", value: "" },
  { label: "Sports Agent", key: "Sports Agent", value: "" },
  { label: "Stock Broker", key: "Stock Broker", value: "" },
  { label: "Tax Accountant", key: "Tax Accountant", value: "" },
  { label: "Tax Auditor", key: "Tax Auditor", value: "" },
  { label: "Tax Lawyer", key: "Tax Lawyer", value: "" },
  { label: "Teacher", key: "Teacher", value: "" },
  { label: "Textile Seller", key: "Textile Seller", value: "" },
  { label: "Travel Agent", key: "Travel Agent", value: "" },
  { label: "TV Presenter", key: "TV Presenter", value: "" },
  { label: "Veterinarian", key: "Veterinarian", value: "" },
  { key: "Waiter", label: "Waiter", value: "" },
  { label: "Waitress", key: "Waitress", value: "" },
  { label: "Watch Repairer", key: "Watch Repairer", value: "" },
  { label: "Wholesale Buyer", key: "Wholesale Buyer", value: "" },
  { label: "Other", key: "Other", value: "" },
];

export const requiredDocuments = [
  {
    key: "cac-certificate-of-registration",
    name: "CAC Certificate of Registration",
    file: null,
    preview: null,
  },
  {
    key: "cac-certificate-of-incorporation",
    name: "CAC Certificate of Incorporation",
    file: null,
    preview: null,
  },
  {
    key: "ctc-memorandum-and-articles-of-association",
    name: "CTC of Memorandum & Articles of Association",
    file: null,
    preview: null,
  },
  {
    key: "ctc-of-form-cac-1.1-director-and-shareholders",
    name: "CTC of Form CAC 1.1 - Director and Shareholder's Details or E-Status Report",
    file: null,
    preview: null,
  },
  {
    key: "ctc-of-the-form-cac-or-it-1",
    name: "CTC of the Form CAC/IT 1",
    file: null,
    preview: null,
  },
  {
    key: "signed-board-resolution-or-business-relationship",
    name: "Signed and Authorized Business Relationship",
    file: null,
    preview: null,
  },
  {
    key: "charter-constitution",
    name: "Charter/Constitution",
    file: null,
    preview: null,
  },
  {
    key: "tin_certificate",
    name: "TIN Certificate",
    file: null,
    preview: null,
  },
  {
    key: "cac-bn-1-form",
    name: "CAC/BN/1Form or E-Status Report",
    file: null,
    preview: null,
  },
  {
    key: "proof-of-business-address",
    name: "Proof of Business Address",
    file: null,
    preview: null,
  },
  {
    key: "scuml-certificate",
    name: "SCUML Certificate",
    file: null,
    preview: null,
  },
  {
    key: "partnership-resolution",
    name: "Partnership Resolution",
    file: null,
    preview: null,
  },
  {
    key: "partnership-deed-or-agreement",
    name: "Partnership Deed/Agreement",
    file: null,
    preview: null,
  },
  {
    key: "operating-license",
    name: "Operating License",
    file: null,
    preview: null,
  },
  {
    key: "signed-approval-or-mandate-letter",
    name: "Signed Letter",
    file: null,
    preview: null,
  },
  {
    key: "additional-supporting-documents",
    name: "Additional Document",
    file: null,
    preview: null,
  },
  {
    key: "ninImg",
    name: "NIN Image",
    file: null,
    preview: null,
  },
  {
    key: "addressImg",
    name: "Proof of Address",
    file: null,
    preview: null,
  },
  {
    key: "liveSelfie",
    name: "Image",
    file: null,
    preview: null,
  },
];

export const individualKyc = ["ninImg", "addressImg", "liveSelfie"];

export const kycCategories = {
  "sole-proprietor": [
    "cac-certificate-of-registration",
    "cac-bn-1-form",
    "proof-of-business-address",
    "partnership-resolutions",
    "partnership-deed-or-agreement",
    "scuml-certificate",
    "tin_certificate",
  ],
  "private-limited-liability-company": [
    "cac-certificate-of-incorporation",
    "ctc-memorandum-and-articles-of-association",
    "ctc-of-form-cac-7-directors-particulars",
    "ctc-of-form-cac-1.1-director-and-shareholders",
    "scuml-certificate",
    "proof-of-business-address",
    "operating-license",
    "tin_certificate",
  ],
  "public-limited-liability-company": [
    "cac-certificate-of-incorporation",
    "ctc-memorandum-and-articles-of-association",
    "ctc-of-form-cac-1.1-director-and-shareholders",
    "proof-of-business-address",
    "scuml-certificate",
    "operating-license",
  ],
  "non-government-organization": [
    "cac-certificate-of-incorporation",
    "ctc-of-the-form-cac-or-it-1",
    "signed-board-resolution-or-business-relationship",
    "proof-of-business-address",
    "scuml-certificate",
  ],
  "government-body": [
    "signed-approval-or-mandate-letter",
    "additional-supporting-documents",
  ],
  "professional-body": [
    "charter-constitution",
    "signed-board-resolution-or-business-relationship",
    "proof-of-business-address",
  ],
};

export const incomeSource = [
  { label: "Occupation", key: "occupation", type: "text" },
  { label: "What is your annual income", key: "annualIncome", type: "text" },
  { label: "Other sources of income", key: "otherIncome", type: "text" },
  { label: "Other Occupation", key: "otherOccupation", type: "text" },
];

export const individualTooltip = `
<div class="custom-tooltip" style="padding: 10px; font-size: 12px">
	<h6>INDIVIDUAL ACCOUNT - TIER 2 - KYC REQUIREMENTS</h6>
	<ul>
		<li>BVN</li>
		<li>Date of Birth</li>
		<li>Phone Number</li>
		<li>Email Address</li>
		<li>Residential Address</li>
		<li>Landmark</li>
		<li>Social Media Platform and Media</li>
		<li>Source of Income</li>
		<li>Selfie (Image)</li>
	</ul>

	<br />

	<h6>INDIVIDUAL ACCOUNT - TIER 3 - KYC REQUIREMENTS</h6>
	<ul>
		<li>NIN Card (Image)</li>
		<li>Proof of Address (Utility Bill - Not older than 3 months)</li>
	</ul>
</div>`;

export const tooltipContent = {
  "sole-proprietor": `
		<div class="custom-tooltip" style="padding: 10px; font-size: 12px">
				<h6>PERSONAL INFORMATION</h6>
				<ul>
					<li>BVN</li>
					<li>Date of Birth</li>
					<li>Phone Number</li>
					<li>Email Address</li>
					<li>Residential Address</li>
					<li>Landmark</li>
					<li>Social Media Platform and Media</li>
				</ul>

				<br />

				<h6>KYC REQUIREMENTS</h6>
				<ul>
					<li>TIN Certificate</li>
					<li>CAC Certificate of Incorporation</li>
					<li>CAC/BN/1 - Application for Registration of Business Name or E-Status Report</li>
					<li>Proof of Business Operating Address (Utility Bill - Not older than 3 months)</li>
					<li>Partnership Deed/Agreement (Partnership Business)</li>
					<li>Partnership Resolution (Partnership Business)</li>
					<li>SCUML Certificate (Where Applicable)</li>
					<li>Business Source of Income</li>
				</ul>
		</div>
	`,
  "private-limited-liability-company": `
		<div class="custom-tooltip" style="padding: 10px; font-size: 12px">
			<h6>PERSONAL INFORMATION</h6>
			<ul>
				<li>BVN</li>
				<li>Date of Birth</li>
				<li>Phone Number</li>
				<li>Email Address</li>
				<li>Residential Address</li>
				<li>Landmark</li>
				<li>Social Media Platform and Media</li>
			</ul>

			<br />

			<h6>KYC REQUIREMENTS</h6>
			<ul>
				<li>TIN Certificate</li>
				<li>CAC Certificate of Incorporation</li>
				<li>CTC of Memorandum & Articles of Association</li>
				<li>CTC of Form CAC 1.1 - Director and Shareholder's Details or E-Status Report</li>
				<li>Proof of Business Operating Address (Utility bill - Not older than 3 months)</li>
				<li>Operating License (where applicable - e.g. Bureau De Change, Payment Solution Service Providers (PSSPs), Mobile Money Operators (MMO), International Money Transfer Operators (IMTOs)</li>
				<li>SCUML Certificate (Where Applicable)</li>				
				<li>Business Source of Income</li>				
				<li>BVN and Date of Birth of Director(s) and shareholder(s)</li>				
			</ul>
		</div>
	`,
  "public-limited-liability-company": `
		<div class="custom-tooltip" style="padding: 10px; font-size: 12px">
			<h6>PERSONAL INFORMATION</h6>
			<ul>
				<li>BVN</li>
				<li>Date of Birth</li>
				<li>Phone Number</li>
				<li>Email Address</li>
				<li>Residential Address</li>
				<li>Landmark</li>
				<li>Social Media Platform and Media</li>
			</ul>

			<br />

			<h6>KYC REQUIREMENTS</h6>
			<ul>
				<li>Tax Identification Number (TIN)</li>
				<li>CAC Certificate of Incorporation</li>
				<li>CTC of Memorandum & Articles of Association</li>
				<li>CTC of Form CAC 1.1 - Director and Shareholder's Details or E-Status Report</li>
				<li>Proof of Business Operating Address (Utility bill - Not older than 3 months)</li>
				<li>Operating License (where applicable - e.g. Bureau De Change, Payment Solution Service Providers (PSSPs), Mobile Money Operators (MMO), International Money Transfer Operators (IMTOs)</li>
				<li>SCUML Certificate (Where Applicable)</li>				
				<li>Source of Income</li>				
				<li>BVN and Date of Birth of Director(s) and shareholder(s)</li>		
			</ul>
		</div>
	`,
  "non-government-organization": `
		<div class="custom-tooltip" style="padding: 10px; font-size: 12px">
			<h6>PERSONAL INFORMATION</h6>
			<ul>
				<li>BVN</li>
				<li>Date of Birth</li>
				<li>Phone Number</li>
				<li>Email Address</li>
				<li>Residential Address</li>
				<li>Landmark</li>
				<li>Social Media Platform and Media</li>
			</ul>

			<br />

			<h6>KYC REQUIREMENTS</h6>
			<ul>
				<li>Tax Identification Number (TIN)</li>
				<li>CAC Certificate of Incorporation</li>
				<li>CTC of Form CAC/IT 1 (Incorporated trustees application form to include the organization's constitution)</li>
				<li>Resolution (or minutes of last meeting) authorizing the establishment of business relationship with PayZeep (Paymi Solutions) on a letter head, duly signed by at least two trustees and nominated signatories/authorizers</li>
				<li>Proof of Business Operating Address (Utility bill - Not older than 3 months)</li>
				<li>SCUML Certificate (Where Applicable)</li>		
				<li>Source of Income</li>				
				<li>BVN and Date of Birth of Director(s) and shareholder(s)</li>			
			</ul>
		</div>
	`,
  "government-body": `
		<div class="custom-tooltip" style="padding: 10px; font-size: 12px">
			<h6>PERSONAL INFORMATION</h6>
			<ul>
				<li>BVN</li>
				<li>Date of Birth</li>
				<li>Phone Number</li>
				<li>Email Address</li>
				<li>Residential Address</li>
				<li>Landmark</li>
				<li>Social Media Platform and Media</li>
			</ul>

			<br />

			<h6>KYC REQUIREMENTS</h6>
			<ul>
				<li>Tax Identification Number (TIN)</li>
				<li>Mandate letter signed by authorized signatory</li>
				<li>Additional Supporting Document (Optional)</li>	
				<li>Source of Income</li>		
			</ul>
		</div>
	`,
  "professional-body": `
		<div class="custom-tooltip" style="padding: 10px; font-size: 12px">
			<h6>PERSONAL INFORMATION</h6>
			<ul>
				<li>BVN</li>
				<li>Date of Birth</li>
				<li>Phone Number</li>
				<li>Email Address</li>
				<li>Residential Address</li>
				<li>Landmark</li>
				<li>Social Media Platform and Media</li>
			</ul>

			<br />

			<h6>KYC REQUIREMENTS</h6>
			<ul>
				<li>Tax Identification Number (TIN)</li>
				<li>Charter/Constitution</li>
				<li>Resolution (or minutes of last meeting) authorizing the establishment of business relationship with PayZeep (Paymi Solutions) on a letter head, duly signed by at least two trustees and nominated signatories/authorizers</li>		
				<li>Proof of Business Operating Address (Utility bill - Not older than 3 months)</li>		
				<li>Source of Income</li>				
				<li>BVN and Date of Birth of Director(s) and shareholder(s)</li>	
			</ul>
		/div>
	`,
};
